import React from "react";
import styled, { keyframes } from "styled-components";

const LoadingShimmer = () => (
  <LoadingWrapper>
    <LoadingText>LOADING</LoadingText>
  </LoadingWrapper>
);

export default LoadingShimmer;

const shimmerGradient = keyframes`
  0%   { background-position: 150% center; }
  100% { background-position: -50% center; }
`;

const LoadingWrapper = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  z-index: 9999;
`;

const LoadingText = styled.div`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 4px;
  background: linear-gradient(90deg, #111 0%, #111 25%, #6a6af8 50%, #111 75%, #111 100%);
  background-size: 300% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${shimmerGradient} 1.5s linear infinite;
  user-select: none;
`;
